import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrow-from-left-icon',
  templateUrl: './navigation-arrow-from-left.component.html'
})
export class NavigationArrowFromLeftComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
